import { useState } from "react";
import axios from "axios";
import { ArrowLeft, LockKeyhole, ShieldCheck } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LOGO_URL } from "@/constants/site";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    try {
      const { data } = await axios.post(`${API}/admin/auth/login`, { email, password });
      localStorage.setItem("nolena-admin-token", data.access_token);
      navigate("/admin", { replace: true });
    } catch (error) {
      toast.error(error.response?.data?.detail || "Giriş yapılamadı. Bilgilerinizi kontrol edin.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="grid min-h-screen place-items-center bg-ink px-5 py-10 text-cream">
      <div className="w-full max-w-md rounded-[2rem] border border-cream/15 bg-surface p-7 text-ink shadow-2xl sm:p-10">
        <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold text-ink/55 transition hover:text-brand"><ArrowLeft className="h-4 w-4" /> Siteye dön</Link>
        <img src={LOGO_URL} alt="Nolena Global" className="mt-9 h-12 w-auto" />
        <div className="mt-8 flex items-center gap-3"><span className="grid h-10 w-10 place-items-center rounded-xl bg-brand/10 text-brand"><ShieldCheck className="h-5 w-5" /></span><div><p className="font-heading text-2xl font-bold">Yönetim paneli</p><p className="text-sm text-ink/55">İçerik ve medya yönetimi</p></div></div>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <label className="block text-sm font-semibold">E-posta<input required type="email" autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} className="mt-2 w-full rounded-xl border border-detail bg-cream px-4 py-3 font-normal outline-none transition focus:border-brand" /></label>
          <label className="block text-sm font-semibold">Şifre<input required type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} className="mt-2 w-full rounded-xl border border-detail bg-cream px-4 py-3 font-normal outline-none transition focus:border-brand" /></label>
          <button disabled={isSubmitting} className="flex w-full items-center justify-center gap-2 rounded-xl bg-brand px-5 py-3.5 font-semibold text-cream transition hover:bg-brand2 disabled:opacity-60"><LockKeyhole className="h-4 w-4" />{isSubmitting ? "Giriş yapılıyor" : "Giriş yap"}</button>
        </form>
      </div>
    </main>
  );
}
